/*
 * PDP "Find Your Mattress Size" size guide (mobile, <=749px).
 *
 * The static parts (trigger card + bottom sheet) are server-rendered by Liquid
 * (sections/main-product.liquid + snippets/pdp-size-guide-sheet.liquid) and gated
 * to eligible product handles there, so there is no injection-driven layout shift.
 * This script only wires the pieces that must attach to DOM injected at runtime by
 * pdp-variant-sheet.js:
 *   - the in-page "Find Your Mattress Size" pill beside .selectSizeLabel
 *   - the two triggers inside the variant drawer (.pdpVariantDrawer)
 *   - relocating the existing .sizechart-popup-label_cstm into the sheet
 *   - open/close of the sheet
 *
 * Perf: no polling timers. A single MutationObserver re-runs the (idempotent) wiring
 * when the variant picker / drawer is (re)built. pdp-variant-sheet.js is not modified.
 */
(function () {
  'use strict';

  if (window.PdpSizeGuide) return;
  window.PdpSizeGuide = true;

  // Mobile only (749px is the theme's canonical breakpoint). Product gating is handled
  // in Liquid, so this script is only emitted on eligible PDPs; on desktop it no-ops.
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

  var HTML = {
    // Size-guide trigger card (used for the in-drawer trigger; the in-page card is Liquid).
    sizeGuideTrigger:
      '<div class="psg_size_guide_trigger_icon">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M2.62458 15.8823C1.37517 14.6329 0.75 14.0077 0.75 13.2313C0.75 12.454 1.37517 11.8288 2.62458 10.5794L10.5794 2.62458C11.8297 1.37517 12.454 0.75 13.2313 0.75C14.0087 0.75 14.6329 1.37517 15.8823 2.62458L17.2087 3.951C18.4582 5.20042 19.0833 5.82558 19.0833 6.602C19.0833 7.37842 18.4582 8.0045 17.2087 9.25392L9.25392 17.2087C8.00358 18.4582 7.3775 19.0833 6.602 19.0833C5.8265 19.0833 5.20042 18.4582 3.951 17.2087L2.62458 15.8823Z" stroke="#A57040" stroke-width="1.5"></path>' +
          '<path d="M6.67536 6.67536L7.97337 7.97337M10.5648 2.78687L11.8609 4.08303M2.78687 10.5648L4.08303 11.8609M4.73111 8.62053L6.67628 10.5648M8.62053 4.73111L10.5648 6.67536" stroke="#A57040" stroke-width="1.5" stroke-linecap="round"></path>' +
        '</svg>' +
      '</div>' +
      '<div class="psg_size_guide_trigger_content">' +
        '<div class="psg_size_guide_trigger_title">Not sure which mattress size to choose?</div>' +
        '<div class="psg_size_guide_trigger_description">' +
          '<span class="psg_size_guide_trigger_description_text">Find the right size for your bed. in a few simple steps.</span>' +
          '<span class="psg_size_guide_trigger_link">' +
            '<span class="psg_size_guide_trigger_link_text">Find Your Mattress Size</span>' +
            '<span class="psg_size_guide_trigger_link_arrow">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="#AC7541" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
            '</span>' +
          '</span>' +
        '</div>' +
      '</div>',

    // Compact "Find Your Mattress Size" pill (in-page + in-drawer).
    findSizeTrigger:
      '<div class="psg_find_size_trigger_icon">' +
        '<svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M9.57242 0.0952311C9.48406 0.0442145 9.35986 0.0824726 9.31225 0.164945L0.0952311 16.1293C0.0442142 16.2176 0.0765817 16.3384 0.164945 16.3895L5.15454 19.2702C5.2429 19.3212 5.3637 19.2888 5.41471 19.2005L14.6317 3.23615C14.6793 3.15368 14.6504 3.02699 14.562 2.97597L9.57242 0.0952311ZM8.39393 2.51737L10.8917 3.95944C10.98 4.01046 11.0974 3.98398 11.1518 3.88973C11.2029 3.80136 11.1705 3.68057 11.0821 3.62955L8.58439 2.18748L9.5435 0.526244L14.2032 3.21652L5.18005 18.8451L0.520352 16.1548L1.48287 14.4877L3.98061 15.9297C4.06897 15.9808 4.18637 15.9543 4.24078 15.86C4.2918 15.7717 4.25943 15.6509 4.17107 15.5999L1.67333 14.1578L2.63244 12.4966L4.46451 13.5543C4.55288 13.6053 4.67367 13.5729 4.72809 13.4787C4.77911 13.3903 4.74674 13.2695 4.65838 13.2185L2.82631 12.1608L3.78542 10.4995L5.61749 11.5573C5.70585 11.6083 5.82665 11.5759 5.87767 11.4876C5.93208 11.3933 5.89632 11.2784 5.80795 11.2274L3.97588 10.1696M4.9384 8.50252L7.43614 9.94459C7.5245 9.99561 7.6419 9.96913 7.69632 9.87488C7.74733 9.78651 7.71496 9.66572 7.6266 9.6147L5.12886 8.17263L6.08797 6.5114L7.92004 7.56914C8.00841 7.62016 8.1292 7.58779 8.18362 7.49354C8.23464 7.40517 8.20227 7.28438 8.11391 7.23336L6.28184 6.17562L7.24095 4.51438L9.07302 5.57213C9.16138 5.62314 9.28218 5.59078 9.3332 5.50241C9.38761 5.40816 9.35185 5.29325 9.26348 5.24224L7.43141 4.18449" fill="#AC7541"></path>' +
        '</svg>' +
      '</div>' +
      '<div class="psg_find_size_trigger_content">Find Your Mattress Size</div>',

    // "Video Guide" block added to the relocated video size-chart label.
    videoGuide:
      '<div class="psg_updated_trigger_content">' +
        '<div class="psg_updated_trigger_content_label">Video Guide</div>' +
        '<div class="psg_updated_trigger_content_title">Watch 1-minute video Guide</div>' +
        '<div class="psg_updated_trigger_content_subtext">See how to measure your bed in less than 1 minute.</div>' +
      '</div>'
  };

  // In-page "Find Your Mattress Size" pill, beside the injected select-size label.
  function wireInPagePill() {
    var label = document.querySelector('.product__info-container .selectSizeInpage .selectSizeLabel');
    if (!label || !label.parentNode) return;
    if (label.parentNode.classList.contains('psg_sizeLabel_wrapper')) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'psg_sizeLabel_wrapper';
    label.parentNode.insertBefore(wrapper, label);
    wrapper.appendChild(label);
    wrapper.insertAdjacentHTML('beforeend',
      '<div class="psg_find_size_mainTrigger_wrapper">' + HTML.findSizeTrigger + '</div>');
  }

  // Move the existing video size-chart label into the sheet (before the footer note) and
  // add the "Video Guide" copy block. The label keeps its own click handler (bound in
  // custom.js) so it still opens the video popup from inside the sheet.
  function wireVideoLabel() {
    var footer = document.querySelector('.psg_size_guide_bottom_sheet_wrapper .psg_bottom_sheet_footer_note');
    if (!footer || !footer.parentNode) return;
    var sheetContent = footer.parentNode;
    var label = document.querySelector('.sizechart-popup-label_cstm');
    if (!label || label.parentNode === sheetContent) return;
    sheetContent.insertBefore(label, footer);
    var inner = label.querySelector('.sizechart-popup-label');
    if (inner && !inner.querySelector('.psg_updated_trigger_content')) {
      inner.insertAdjacentHTML('beforeend', HTML.videoGuide);
    }
  }

  // Variant drawer: size-guide trigger after the measure-info prompt, pill before the converter.
  function wireDrawerTriggers() {
    var measure = document.querySelector('.pdpVariantDrawer .variantMeasureInfoWrap');
    if (measure && measure.parentNode &&
        !measure.parentNode.querySelector('.psg_size_guide_sheetTrigger_wrapper')) {
      measure.insertAdjacentHTML('afterend',
        '<div class="psg_size_guide_sheetTrigger_wrapper">' + HTML.sizeGuideTrigger + '</div>');
    }
    var converter = document.querySelector('.pdpVariantDrawer .converter_wrapper');
    if (converter) {
      var prev = converter.previousElementSibling;
      if (!(prev && prev.classList.contains('psg_find_size_sheetTrigger_wrapper'))) {
        converter.insertAdjacentHTML('beforebegin',
          '<div class="psg_find_size_sheetTrigger_wrapper">' + HTML.findSizeTrigger + '</div>');
      }
    }
  }

  function wireUp() {
    wireInPagePill();
    wireVideoLabel();
    wireDrawerTriggers();
  }

  function openSheet() {
    document.body.classList.add('psg_size_guide_bottom_sheet_active');
    var container = document.querySelector('.psg_size_guide_bottom_sheet_container');
    if (container) container.scrollTop = 0;
  }

  function closeSheet() {
    document.body.classList.remove('psg_size_guide_bottom_sheet_active');
  }

  function init() {
    document.body.classList.add('psg');

    // Open/close — one delegated listener, works wherever the triggers live.
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (target.closest(
        '.psg_size_guide_mainTrigger_wrapper, .psg_find_size_mainTrigger_wrapper, ' +
        '.psg_size_guide_sheetTrigger_wrapper, .psg_find_size_sheetTrigger_wrapper'
      )) {
        openSheet();
        return;
      }
      if (target.closest(
        '.psg_bottom_sheet_close_btn, .psg_bottom_sheet_back_btn, .psg_size_guide_bottom_sheet_overlay'
      )) {
        closeSheet();
      }
    });

    wireUp();

    // Re-wire when pdp-variant-sheet.js (re)builds the in-page picker / drawer, or when
    // <product-info> re-renders on a variant change. One coalesced, idempotent observer,
    // anchored on a node that survives a variant-change section re-render (the inner
    // .product__info-container can be replaced, which would silently kill the observer).
    var scope = document.querySelector('product-info')
      || document.querySelector('.product.product--medium')
      || document.body;
    var scheduled = false;
    var raf = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      raf(function () { scheduled = false; wireUp(); });
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
